export default [
                 {//[0] => Settings de Bancos
                  slidesToShow: 4,//con MP era 5
                  slidesToScroll: 1,
                  autoplay: true,
                  arrows: false,
                  autoplaySpeed: 6000,
                  lazyLoad: false,//con MP era true
                  responsive: [
                    {
                      breakpoint: 992,
                      settings: {
                        slidesToShow: 4,
                        slidesToScroll: 2,
                        infinite: true
                      }
                    },
                    {
                      breakpoint: 767,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                      }
                    },
                    {
                      breakpoint: 575,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                      }
                    }
                  ]
                },
                {//[1] => SETINGS DE CATEGORIAS
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  autoplay: true,
                  arrows: true,
                  infinite: true,
                  lazyLoad: true,
                  autoplaySpeed: 5000,
                  responsive: [
                    {
                      breakpoint: 767,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                  ]
                },
                {//[2] => SETINGS DE DESTINOS
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  lazyLoad: true,
                  autoplay: true,
                  arrows: true,
                  autoplaySpeed: 4000,
                  infinite: true,
                  initialSlide: 0,
                  responsive: [
                    {
                      breakpoint: 992,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true
                      }
                    },
                    {
                      breakpoint: 575,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                  ]
                },
                {//[3] => SETINGS DE IMAGENES DEL PRODUCTO
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  autoplay: true,
                  arrows: true,
                  autoplaySpeed: 4000,
                  infinite: true,
                  className: 'slides'
                },
                {//[4] => SETINGS DE IMAGENES DEL BANNER
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  autoplay: true,
                  arrows: false,
                  dots: true,
                  autoplaySpeed: 4000,
                  infinite: true,
                  initialSlide:0,
                  lazyLoad: true,
                  dotsClass: 'slick-dots dotsPropios'
                }
              ];



// WEBPACK FOOTER //
// ./src/components/Home/carouselSettings.js